var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    [
      _c(
        "v-layout",
        { attrs: { row: "", wrap: "" } },
        [
          _c(
            "v-flex",
            { attrs: { xs12: "", lg12: "", "mb-3": "" } },
            [
              _c(
                "v-expansion-panel",
                { attrs: { popout: "" } },
                _vm._l(_vm.panels, function(panel) {
                  return _c(
                    "v-expansion-panel-content",
                    {
                      staticClass: "custom-panels",
                      scopedSlots: _vm._u(
                        [
                          _vm.showCheck(panel.checkId)
                            ? {
                                key: "header",
                                fn: function() {
                                  return [
                                    _c("div", [
                                      _c(
                                        "span",
                                        {
                                          staticStyle: { "font-weight": "bold" }
                                        },
                                        [_vm._v(_vm._s(panel.title))]
                                      )
                                    ])
                                  ]
                                },
                                proxy: true
                              }
                            : null
                        ],
                        null,
                        true
                      )
                    },
                    [
                      _c(
                        "v-card",
                        [_c(panel.component, { tag: "component" })],
                        1
                      )
                    ],
                    1
                  )
                }),
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }